import { render, staticRenderFns } from "./TabEditor.vue?vue&type=template&id=7c8f695e&scoped=true&"
import script from "./TabEditor.vue?vue&type=script&lang=ts&"
export * from "./TabEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8f695e",
  null
  
)

export default component.exports